import { create } from 'zustand';

// CUTSCENES — stepping into a scene the artists are playing out.
//
// Khari, 2026-10-23: *"the signal and soul 3D example uses close-up shots and
// planned views. We should make cut scenes the same way.. If you step into the
// artist's daily story, there will be portions where your control is disabled
// while the narrated scene takes over.. when the view goes back to yours, you
// can follow along"* — and of the artists' street conversations, *"this would
// be great for listening to conversations as well."*
//
// One piece for both (components/city/CityCutscene): who is in the scene, who
// is speaking, where they stand. Nobody is pulled in: the cue is offered only
// to someone already there, stepping in is theirs to choose, and Leave is
// always on screen (every wait needs a door).
//
//   cue      what is on offer right here (a conversation, a story scene)
//   target   what this visitor stepped into
//   phase    'off' · 'cut' (the scene has the camera) · 'follow' (yours again,
//            following along — a story between scenes, a walk, a drive)

/** Read every frame by the street's WalkControls: while true it stands down. */
// `active`: a scene has the camera (WalkControls stand down).
// `at`: where the visitor is really standing while it does (their saved view) —
//   what they HEAR is from there, never from the shot (Khari, 2026-10-23: "the
//   volume adjusts based on the view of the camera. That should not happen").
// `scene`: the scene that has the camera, { kind: 'conv' | 'story', id } — it
//   plays at one steady level for as long as it does.
export const cutsceneBridge = { active: false, at: null, scene: null };

export const useCutscene = create((set) => ({
  cue: null,       // { kind: 'conv' | 'story', id, title, sub }
  target: null,    // { kind, id, title }
  phase: 'off',
  caption: null,   // { name, text } — the line being said, during a cut
  followName: null,
  followWay: null,   // { deg, dist } — which way the lead is, while following
  offer: null,       // { kind: 'artist', id, title, until } — "Walk with Avva", after a chat ends
  // Cues waved away with ✕ (Khari, 2026-11-01: "add an X button to dismiss the
  // current conversation invite"), as `${kind}:${id}`: that conversation, set or
  // story is not offered again this visit; the next one still is.
  dismissed: new Set(),
  setCue: (cue) => set({ cue }),
  dismissCue: () => set((s) => (s.cue ? { cue: null, dismissed: new Set([...s.dismissed, `${s.cue.kind}:${s.cue.id}`]) } : {})),
  stepIn: (target) => set({ target, phase: 'off', caption: null, offer: null }),
  leave: () => set({ target: null, phase: 'off', caption: null, followName: null, followWay: null }),
  setFollowWay: (followWay) => set({ followWay }),
  setOffer: (offer) => set({ offer }),
  setPhase: (phase) => set({ phase }),
  setCaption: (caption) => set({ caption }),
  setFollowName: (followName) => set({ followName }),
}));

if (import.meta.env.DEV && typeof window !== 'undefined') window.__cutscene = useCutscene;
